import {
  Zap,
  ShoppingCart,
  Search,
  Code2,
  ToggleLeft,
  Settings2,
  Users,
} from "lucide-react";

import type { FeatureFlag, InviteFormState, SiteConfig } from "./types";

// ---------------------------------------------------------------------------
// Departments (matches seed data — Direction, Sales, Logistics, Finance, Products)
// ---------------------------------------------------------------------------

export const DEPARTMENTS = [
  { id: "direction", label: "Direction" },
  { id: "sales", label: "Sales" },
  { id: "logistics", label: "Logistics" },
  { id: "finance", label: "Finance" },
  { id: "products", label: "Products" },
] as const;

// ---------------------------------------------------------------------------
// Tabs
// ---------------------------------------------------------------------------

export const TABS = [
  { key: "flags", label: "Drapeaux", icon: ToggleLeft },
  { key: "config", label: "Configuration", icon: Settings2 },
  { key: "admins", label: "Administrateurs", icon: Users },
] as const;

export type TabKey = (typeof TABS)[number]["key"];

// ---------------------------------------------------------------------------
// Feature flag categories
// ---------------------------------------------------------------------------

export const FLAG_CATEGORIES = [
  { key: "performance", label: "Performance", icon: Zap },
  { key: "ecommerce", label: "E-commerce", icon: ShoppingCart },
  { key: "seo", label: "SEO", icon: Search },
  { key: "dev", label: "Développement", icon: Code2 },
] as const;

// ---------------------------------------------------------------------------
// Feature flags
// ---------------------------------------------------------------------------

export const FEATURE_FLAGS: readonly FeatureFlag[] = [
  {
    key: "skeleton_screens",
    name: "Écrans squelette",
    description:
      "Affiche des placeholders animés pendant le chargement des données.",
    scope: "Vitrine",
    category: "performance",
  },
  {
    key: "lazy_images",
    name: "Images paresseuses",
    description:
      "Charge les images uniquement lorsqu'elles sont visibles à l'écran.",
    scope: "Vitrine",
    category: "performance",
  },
  {
    key: "realtime_updates",
    name: "Mises à jour en temps réel",
    description:
      "Active les notifications push et les mises à jour instantanées.",
    scope: "Admin",
    category: "performance",
  },
  {
    key: "pwa_mode",
    name: "Mode PWA",
    description:
      "Permet l'installation de l'application sur l'écran d'accueil.",
    scope: "Vitrine",
    category: "performance",
  },
  {
    key: "optimistic_ui",
    name: "UI optimiste",
    description:
      "Met à jour l'interface immédiatement avant la confirmation serveur.",
    scope: "Admin",
    category: "performance",
  },
  {
    key: "price_validation",
    name: "Validation des prix",
    description:
      "Vérifie la cohérence des prix avant l'affichage au client.",
    scope: "Vitrine",
    category: "ecommerce",
  },
  {
    key: "dynamic_seo",
    name: "SEO dynamique",
    description:
      "Génère les balises meta et les données structurées automatiquement.",
    scope: "Vitrine",
    category: "seo",
  },
  {
    key: "e2e_testids",
    name: "Test IDs E2E",
    description:
      "Ajoute des attributs data-testid pour les tests automatisés.",
    scope: "Vitrine",
    category: "dev",
  },
  {
    key: "error_boundaries",
    name: "Barrières d'erreurs",
    description:
      "Capture les erreurs par section pour éviter un crash complet.",
    scope: "Admin",
    category: "dev",
  },
] as const;

// ---------------------------------------------------------------------------
// Storage key
// ---------------------------------------------------------------------------

export const STORAGE_KEY_FLAGS = "djayma-feature-flags";

// ---------------------------------------------------------------------------
// Default site configuration
// ---------------------------------------------------------------------------

export const DEFAULT_CONFIG: SiteConfig = {
  siteName: "Djayma",
  contactEmail: "",
  contactPhone: "+221 ",
  minOrderAmount: 5000,
  deliveryEnabled: true,
  maintenanceMode: false,
  currency: "FCFA",
  timezone: "Africa/Dakar",
};

// ---------------------------------------------------------------------------
// Invite form defaults
// ---------------------------------------------------------------------------

export const EMPTY_INVITE_FORM: InviteFormState = {
  email: "",
  full_name: "",
  role: "agent",
  department_id: "",
  platform: "djayma",
};
